// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"35":"781a7dc3","60":"927b833a","535":"59c91d9f","772":"0d0937cf","819":"4f8ce624","841":"51aa1005"}[chunkId] + ".css";
};